import { mapGetters, mapActions } from "vuex";
import { required, requiredIf, email, minLength, requiredUnless } from "vuelidate/lib/validators";
import {
    Drop
} from "vue-easy-dnd";

export default {
    name: "TableauDestinataires",
    components: {
        Drop
    },
    props: {
        destinataires: Array,
        perPage: Number,
        editable: {
            type: Boolean,
            default: true,
        },
        status: {
            type: Boolean,
            default: false,
        },
        showDocs: {
            type: Boolean,
            default: false,
        },
        docs: Array,
        commande: Object,
        isEnvoiLetreco: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            currentPage: 1,
            id: "tabDest0",
            downloadAck: false,
            filter: {
                text: "",
                type: "all",
            },
            dragover: -1,
            fields: [
                { key: 'nom', sortable: true },
                { key: 'mail', sortable: true },
                { key: 'adresse', sortable: true },
                { key: 'electronique', sortable: true },
                { key: 'recommande', sortable: true },
                { key: 'envoi_email', sortable: true },
                { key: 'envoi_simple', sortable: true },
            ],
            selectedDestinataireIndex : -1,
            selectedDestinataire: {
                id: -1,
                civilite: "",
                nom: "",
                prenom: "",
                adresse: "",
                ville: "",
                code_postal: "",
                pays: "",
                mail: "",
                recommande: 0,
                electronique: 0,
                envoi_simple: 0,
                envoi_email: 0,
            },
            selectedDestinataireRef: {},
            perPageSelected: 5,
        };
    },
    computed: {
        ...mapGetters(["auth"]),
        rows() {
            return this.destinataires.length
        },
        modalId() {
            return "dest-modal-"+ ( (this.commande != undefined) ? this.commande.id : 'new')
        },
        isAdmin() {
            if(this.auth && this.auth.user && this.auth.user.roles &&
                this.auth.user.roles.find((role) => role.name === "admin")) {
                return true
            }
            return false
        },
    },
    validations() {
        return { // ,
            selectedDestinataire: {
                nom: { required, minLength: minLength(2) },
                adresse: { required: requiredUnless('electronique'), minLength: minLength(2) },
                mail: { required: requiredIf('electronique'), email },
                ville: { required: requiredUnless('electronique'), minLength: minLength(2) },
                code_postal: { required: requiredUnless('electronique') },
                electronique: {},
                recommande: {},
                civilite: {},
                envoi_simple: {},
                envoi_email: {},
            }
        }
    },
    methods: {
        ...mapActions([
            'getAcquittement', 'getDepositProof', 'getARPrepaFacile', 'exportDestinataires', 'exportDestinatairesPrepaFacile', 'exporFicheTravailSyndic'
        ]),
        onFiltered(filteredItems) {
            this.currentPage = 1
        },
        destinatairesFilter(row, filter) {
            let filterText = filter.text.trim().toLowerCase()
            if(filterText != "") {
                let destinataireString = (row.nom + " " + row.prenom + " " + row.mail + " " + row.adresse + " " + row.ville + " " + row.code_postal + " " + row.pays).toLowerCase().trim()
                let filterResult = destinataireString.includes(filterText)
                if(filterResult == false) return false
            }
            if(this.filter.type == "all") return true
            else if(this.filter.type === "recommande") return row.recommande === 1
            else if(this.filter.type === "electronique") return row.electronique === 1
            else if(this.filter.type === "envoi_email") return row.envoi_email === 1
            else if(this.filter.type === "envoi_simple") return  row.envoi_email === 0 && row.electronique === 0 && row.recommande === 0
            return false
        },
        filtreParType(filtre) {
            this.filter.type = filtre
        },
        envoiSimple(event, row) {
            if(event.target.checked) {
                row.item.electronique = 0
                row.item.envoi_email = 0
                row.item.recommande = 0
                this.$emit('update-destinataires')
            }
        },
        validateEmail(email) {
            var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
            if (email.match(validRegex)) {
              return true;
            }
            return false;
        },
        validateNom(nomPrenon) {
            var validRegex = /^[0-9a-zA-Z ]+$/;
            if (nomPrenon.match(validRegex)) {
                return true;
              }
              return false;
        },
        dropHandler(destinataire, event) {
            event.destinataire = destinataire
            this.dragover = -1
            this.$emit("dropOnDest", event)
        },
        empty() {
            this.destinataires.splice(0, this.destinataires.length)
            this.$emit('update-destinataires')
        },
        cancel() {
            this.$bvModal.hide(this.modalId)
        },
        
        save() {
            if(this.selectedDestinataireIndex === -1) {
                this.selectedDestinataire.id = 0
                this.destinataires.push(this.selectedDestinataire)
            } else {
                this.destinataires.splice(this.selectedDestinataireIndex, 1, this.selectedDestinataire)
            }
            this.$bvModal.hide(this.modalId)
            this.$emit('update-destinataires')
        },
        deleteDest() {
            this.destinataires.splice(this.selectedDestinataireIndex, 1)
            this.$bvModal.hide(this.modalId)
            this.$emit('update-destinataires')
            
        },
        create() {
            Object.assign(this.selectedDestinataire, {
                civilite: "",
                nom: "",
                prenom: "",
                adresse: "",
                ville: "",
                code_postal: "",
                pays: "",
                mail: "",
                uid: Math.floor(Date.now() / 1000).toString(36) + Math.random().toString(36).slice(-6),
                electronique: this.isEnvoiLetreco ? 1 : 0,
                recommande: 0,
            })
            this.selectedDestinataireIndex = -1
            this.$bvModal.show(this.modalId)
        },
        editField(item, index, evt) {
            if(!item.uid) {
                item.uid = Math.floor(Date.now() / 1000).toString(36) + Math.random().toString(36).slice(-6)
            }
            if(this.editable) {
                this.selectedDestinataire = Object.assign({}, item)
                this.selectedDestinataireIndex = this.destinataires.findIndex(d => d.uid === item.uid)
                if(!item.avancement || item.avancement === 0) {
                    this.$bvModal.show(this.modalId)
                }
            }
        },
        setPerPage(num) {
            this.perPageSelected = num;
            this.currentPage = 1;
        },
        telechargerAcquittement(reference, destinataire) {
            this.downloadAck = true;
            this.getAcquittement({reference:reference, email:destinataire.mail}).then(() => {this.downloadAck = false})
        },
        telechargerPreuveDeDepot(reference) {
            this.downloadAck = true;
            this.getDepositProof(reference).then(() => {this.downloadAck = false})
        },
        telechargerAcquittementPrepaFacile(destinataire) {
            this.downloadAck = true;
            this.getARPrepaFacile(destinataire).then(() => {this.downloadAck = false})            
        },
        avancementToIcon(code) {
            if(code <= 1) {
                return '<i class="far fa-clock"></i>';
            } else if(code === 2) {
                return '<i class="far fa-paper-plane"></i>';
            } else if(code === 3) {
                return '<i class="fas fa-flag-checkered"></i>';
            } else if(code === 4) {
                return '<i class="fas fa-exclamation-circle"></i>';
            } else if(code === 5) {
                return '<i class="fas fa-paper-plane"></i>';
            } else if(code === 12) {
                return '<i class="fas fa-hourglass-end"></i>';
            } else if(code === undefined) {
                return "<input type='checkbox' disabled checked>";
            }
            return '<i class="fas fa-bug"></i>';
        },
        avancementToText(item) {
            if(item.extra && item.electronique === 1) {
                return { 
                    title: 'Envoi rejeté par l\'API LetReco',
                    content: item.extra,
                    html: true
                }
            } else if(item.avancement <= 1) {
                return 'À expédier';
            } else if(item.avancement === 2) {
                return 'Expédié, en attente d\'acquittement';
            } else if(item.avancement === 3) {
                return 'Acquitté';
            } else if(item.avancement === 4) {
                return 'Rejeté';
            } else if(item.avancement === 5) {
                return 'Expédié';
            } else if(item.avancement === 6) {
                return 'Délivré';
            } else if(item.avancement === 12) {
                return 'Expiré';
            } else if(item.avancement === undefined) {
                return "Envoi electronique";
            }
            return 'En erreur, code:'+item.avancement;
        },
        docsToText(item) {
            const commonListForDest = this.docs.filter(
                doc => ((Array.isArray(doc.destinataire) && (doc.destinataire.find(ds => ds.mail === 'all') || doc.destinataire.length === 0)) 
                            || doc.destinataire_id === null))
            const personnalListForDest = this.docs.filter(
                doc => (Array.isArray(doc.destinataire) && (doc.destinataire.find(ds => ds.mail === item.mail)) 
                            || (doc.destinataire_id && doc.destinataire_id === item.id)))
            if(commonListForDest.length > 0 || personnalListForDest.length > 0) {
                let contenu = commonListForDest.map(doc => '<span><i class="fas fa-users"></i> ' + (doc.title ? doc.title : doc.libelle) + '</span>').join('<br/>');
                contenu += "<BR/>" 
                contenu += personnalListForDest.map(doc => '<span class="personalDoc"><i class="fas fa-user-tag"></i> ' + (doc.title ? doc.title : doc.libelle) + '</span>').join('<br/>');
                return {
                    title: 'Documents envoyés à '+ (item.nom ? item.nom : '') + ' ' + (item.prenom ? item.prenom : ''),
                    content: contenu,
                    customClass: 'popover-document',
                    html: true,
                }
            } else {
                return {
                    title: 'Documents envoyés à '+ (item.nom ? item.nom : '') + ' ' + (item.prenom ? item.prenom : ''),
                    content: '<span style="color:red;font-weight:bold"><i class="fas fa-exclamation-triangle"></i> Aucun document à envoyer</span>',
                    html: true,
                }
            }
        },
        docsToIcon(item) {
            const commonListForDest = this.docs.filter(
                doc => ((Array.isArray(doc.destinataire) && (doc.destinataire.find(ds => ds.mail === 'all') || doc.destinataire.length === 0)) 
                            || doc.destinataire_id === null))
            const personnalListForDest = this.docs.filter(
                doc => (Array.isArray(doc.destinataire) && (doc.destinataire.find(ds => ds.mail === item.mail)) 
                            || (doc.destinataire_id && doc.destinataire_id === item.id)))
            const total = commonListForDest.length + personnalListForDest.length
            if(commonListForDest.length > 0 || personnalListForDest.length > 0) {
                return '<span class="badge badge-pill doc-button">'+total+'</span>'
            } else {
                return '<i style="color:red" class="fas fa-exclamation-triangle"></i>'
            }
        },

    },
    mounted () {
        // id unique pour garantir que meme auqnd il y a plusieurs tableaux destinataires
        // chacun aura un id unique
        this.perPageSelected = this.perPage
        this.id = "tabDest"+this._uid
        if(this.status && this.commande) {
            if(this.commande.categorie.code != 'letreco') {
                this.fields.splice(3,0,{ key: 'ref_suivi', sortable: true })
            }
            this.fields.push({ key: 'statut', sortable: true, sortByFormatted: true, formatter: (value, key, item) => {
                return item.avancement
            }})
        }
        if(this.showDocs) {
            this.fields.push({ key: 'docs', sortable: false})
        }
        // si letreco on enleve la colonne recommandé, envoi simple et envoi mail
        if(this.isEnvoiLetreco) {
            this.fields.splice(this.fields.findIndex(f => f.key === 'recommande'),1)
            this.fields.splice(this.fields.findIndex(f => f.key === 'envoi_email'),1)
            this.fields.splice(this.fields.findIndex(f => f.key === 'envoi_simple'),1)
        }
    }
};
